import history from "../routes/history";
import { api } from "./api";

class Auth {
	token = localStorage.getItem("token");

	getToken() {
		return !!this.token;
	}

	async isAuth() {
		if (!this.getToken()) {
			return false;
		}

		const { data } = await api.post(
			"/check-token",
			{},
			{
				headers: {
					authorization: `Bearer ${this.token}`,
				},
			}
		);

		if (!data.ok) {
			return false;
		}
		return true;
	}

	Logout() {
		if (this.isAuth()) {
			localStorage.removeItem("token");
			localStorage.removeItem("active-page");
			localStorage.removeItem("table-active");
			history.push({ pathname: "/" });
		}
	}
}
export { Auth };
